// The book — one number, split by how close each part is to closing.
//
// Replaces four tiles that each carried a figure and none of which said how
// much of it was real. $328M in underwriting and $328M in diligence are
// different books; the stacked bar is what tells them apart.
import { stageRamp } from "../common/brand";
import { STAGE_LABEL } from "../../services/homeView";

const M = (v) => `$${(v / 1e6).toFixed(1)}M`;

export default function BookHero({ book, bind }) {
  const { total, rows, totalSf, psf, offMarket, byStage } = book;
  return (
    <section data-print-block className="rounded-[14px] border border-[#3a3a3a] bg-[#242424] px-6 py-5">
      <div className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8a8a8a]">Under review · underwriting and later</div>
      <div className="mt-2.5 text-[60px] font-light leading-none tracking-[-0.035em] text-[#f4f4f4]">
        {rows.length ? M(total) : "—"}
      </div>
      <div className="mt-2.5 text-[13px] text-[#b4b4b4]">
        <b className="font-semibold text-[#f4f4f4]">{rows.length}</b> deal{rows.length === 1 ? "" : "s"}
        {" · "}<b className="font-semibold text-[#f4f4f4]">{(totalSf / 1e6).toFixed(2)}M</b> SF
        {psf != null && <>{" · "}<b className="font-semibold text-[#f4f4f4]">${Math.round(psf)}</b>/SF</>}
        {" · "}<b className="font-semibold text-[#f4f4f4]">{offMarket} of {rows.length}</b> sourced off-market
      </div>

      {total > 0 && (
        <div className="mt-5 flex h-3.5 gap-[2px]">
          {byStage.filter((b) => b.value > 0).map((b, i, arr) => (
            <div key={b.stage}
              {...bind(<><div className="text-[10.5px] text-[#8a8a8a]">{STAGE_LABEL[b.stage]}</div>{M(b.value)} · {b.n} deal{b.n === 1 ? "" : "s"} · {Math.round((b.value / total) * 100)}%</>)}
              className={`${i === 0 ? "rounded-l" : ""} ${i === arr.length - 1 ? "rounded-r" : ""}`}
              style={{ width: `${(b.value / total) * 100}%`, background: stageRamp[b.stage] }} />
          ))}
        </div>
      )}

      <div className="mt-3.5 flex flex-wrap gap-x-6 gap-y-2">
        {byStage.map((b) => (
          <div key={b.stage} className="flex items-baseline gap-2 text-[12px]">
            <span className="inline-block h-[9px] w-[9px] translate-y-[1px] rounded-[2px]" style={{ background: stageRamp[b.stage] }} />
            <span className="text-[#b4b4b4]">{STAGE_LABEL[b.stage]}</span>
            <span className="font-semibold text-[#f4f4f4]">{M(b.value)}</span>
            <span className="text-[#8a8a8a]">{b.n} deal{b.n === 1 ? "" : "s"}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
